module.exports = __webpack_public_path__ + "img/extended.2e509c69.png";